"use client";

import Link from "@casino/client/components/Link";
import { Button, cn } from "@workspace/frontend-ui";

type Props = {
  isMobile?: boolean;
  href?: string;
};

const BannerCtaButton: FC<Props> = ({ children, isMobile, href }) => (
  <Link href={href || "/"}>
    <Button
      className={cn("main-banner-logged-out-button", isMobile && "w-full")}
    >
      {children}
    </Button>
  </Link>
);

export default BannerCtaButton;
